import { useQuery } from '@tanstack/react-query'
import { localSearchProspects } from '../services/api.js'

export function useLocalProspectsSearch(formData) {
  const { jobTitle = '', location = '', sector = '' } = formData || {}

  const enabled = !!(jobTitle.trim() || location.trim() || sector.trim())

  const { data, isLoading } = useQuery({
    queryKey: ['localProspects', jobTitle, location, sector],
    queryFn: () => localSearchProspects({ jobTitle, location, sector }),
    enabled,
    staleTime: 30_000,
  })

  return {
    localResults: data?.prospects || [],
    localLoading: enabled && isLoading,
  }
}
